var map = {
	"./2022-02-27 15.06.26.png": 67,
	"./2022-02-27 15.06.38.png": 68,
	"./2022-02-27 19.08.55.png": 69,
	"./2022-02-27 19.09.16.png": 70,
	"./DSC06584.png": 71,
	"./corgi-cannonbeach.png": 72
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66;